module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_tvb@2x-0d4a0abdde4e29ef7c0a8efae13260c5.webp";